import { render, staticRenderFns } from "./MethodAuthorization.vue?vue&type=template&id=218ae371"
import script from "./MethodAuthorization.js?vue&type=script&lang=js&external"
export * from "./MethodAuthorization.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports